<template>
  <div>
    <Modal v-model="visible" title="更换模板" :loading="$root.$children[0].modalLoading" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <Form ref="form" :model="form" :label-width="80" class="modal-form">
        <FormItem :label="detail.nodeType == 2?'团队' : '机构'">
          <span>{{ detail.name }}</span>
        </FormItem>
        <FormItem label="原模板:">
          <span>{{ templateDetail.name }}</span>
        </FormItem>
        <FormItem prop="newTemplateId" label="新模板:" :rules="$units.formRule.required('请选择新模板')">
          <Select v-model="form.newTemplateId" transfer filterable clearable style="width: 80%">
            <Option v-for="(item, index) in templateList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
          <span class="add-template" @click="$refs.addTemplate.open({})">新建模板</span>
        </FormItem>
        <div class="info-text">更换后，该机构/团队的产品和服务费将变更为新模板内的产品和服务费</div>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="ok" :loading="loading">确定</Button>
      </div>
    </Modal>

    <!-- 进度弹窗 -->
    <modalLoading ref="loading"></modalLoading>

    <!-- 新增模板 -->
    <edit-template ref="addTemplate" @success="getTemplateList()"></edit-template>
  </div>
</template>

<script>
import modalLoading from '@/components/commons/modalLoading';
import editTemplate from '@/components/commons/feeTemplate/editTemplate';

export default {
  props: ['templateDetail'],

  components: {
    modalLoading,
    editTemplate
  },

  data() {
    return {
      visible: false,
      form: {},
      templateList: [],
      loading: false,
      type: null,
      detail: {},
      templateId: null
    };
  },

  methods: {
    // type:true-设置模板，false-变更模板
    // detail-机构/团财详情
    // templateId-当前模板id
    open(type, detail, templateId) {
      this.form = {};
      this.visible = true;
      this.type = type;
      this.detail = detail;
      this.templateId = templateId;
      this.getTemplateList();
    },

    // 获取模板下拉列表
    getTemplateList() {
      this.$http({
        url: '/buz/template/getOrgTemplateList',
        type: 'GET',
        data: {
          orgId: this.detail.nodeType == 1 ? this.detail.parentId : this.detail.orgId, //nodeType:1机构，2团队
          templateType: this.detail.nodeType
        }
      }).then(res => {
        this.templateList = res.data.filter(item => item.id != this.templateId);
      });
    },

    ok() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.loading = true;
        this.$refs.loading.open({
          title: '正在联动调整产品服务费，请稍等',
          content: '系统将自动根据下级占上级的服务费占比联动调整相关机构或团队的产品服务费',
          descText: '（如，上级为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动根据上下级的原服务费占比，进行下调，即下级调至15%）'
        });

        this.$http({
          url: '/buz/commission/switchTemplate',
          type: 'POST',
          data: {
            oldTemplateId: this.templateDetail.id,
            newTemplateId: this.form.newTemplateId,
            orgId: this.detail.id,
            templateType: this.detail.nodeType
          }
        })
          .then(res => {
            this.visible = false;
            this.$emit('success');
            this.loading = false;
            this.$refs.loading.setText({ progress: 100 });
          })
          .catch(e => {
            this.loading = false;
            this.$refs.loading.open({
              title: '调度失败!',
              progress: 99,
            });
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.add-template {
  color: #236dff;
  float: right;
  cursor: pointer;
}
</style>